<template>
  <main>
    <router-view />
  </main>
</template>
